module.exports = __webpack_public_path__ + "static/media/delivery.63116967.svg";